var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "main" }, [
    _c("div", { staticClass: "form" }, [
      _c("div", { staticClass: "form-row" }, [
        _c("fieldset", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.firstName,
                expression: "form.firstName",
              },
            ],
            class: { error: !_vm.validate.firstName },
            attrs: {
              placeholder: "First Name*",
              type: "text",
              tabindex: "1",
              required: "",
              autofocus: "",
            },
            domProps: { value: _vm.form.firstName },
            on: {
              focus: function ($event) {
                _vm.validate.firstName = true
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "firstName", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("fieldset", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.lastName,
                expression: "form.lastName",
              },
            ],
            class: { error: !_vm.validate.lastName },
            attrs: {
              placeholder: "Last Name*",
              type: "text",
              tabindex: "2",
              required: "",
            },
            domProps: { value: _vm.form.lastName },
            on: {
              focus: function ($event) {
                _vm.validate.lastName = true
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "lastName", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c("fieldset", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.emailAddress,
                expression: "form.emailAddress",
              },
            ],
            class: { error: !_vm.validate.emailAddress },
            attrs: {
              placeholder: "Email Address*",
              type: "email",
              tabindex: "3",
              required: "",
            },
            domProps: { value: _vm.form.emailAddress },
            on: {
              focus: function ($event) {
                _vm.validate.emailAddress = true
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "emailAddress", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("fieldset", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.emailAddressVerify,
                expression: "form.emailAddressVerify",
              },
            ],
            staticClass: "emailAddressVerify",
            attrs: {
              placeholder: "Verify Email Address*",
              type: "email",
              tabindex: "3",
              required: "",
            },
            domProps: { value: _vm.form.emailAddressVerify },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "emailAddressVerify", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("fieldset", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.phoneNumber,
                expression: "form.phoneNumber",
              },
            ],
            class: { error: !_vm.validate.phoneNumber },
            attrs: {
              placeholder: "Phone Number*",
              type: "tel",
              tabindex: "4",
              required: "",
            },
            domProps: { value: _vm.form.phoneNumber },
            on: {
              focus: function ($event) {
                _vm.validate.phoneNumber = true
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "phoneNumber", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.message,
            expression: "form.message",
          },
        ],
        class: { error: !_vm.validate.message },
        attrs: { placeholder: "How can we help you?", rows: "5" },
        domProps: { value: _vm.form.message },
        on: {
          focus: function ($event) {
            _vm.validate.message = true
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.form, "message", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("fieldset", { staticClass: "checkbox mt-4" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.accept,
              expression: "accept",
            },
          ],
          attrs: { type: "checkbox", id: "agreement" },
          domProps: {
            checked: Array.isArray(_vm.accept)
              ? _vm._i(_vm.accept, null) > -1
              : _vm.accept,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.accept,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.accept = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.accept = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: "agreement" } }, [
          _vm._v(
            "By checking this box I agree to I agree to receive SMS from Beltone Alliance. Standard text messaging rates apply.  I can opt out at any time. "
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.recaptchaSuccess
        ? _c("label", { staticClass: "recaptcha-error" }, [
            _vm._v('Please check the "I\'m not a robot" box to continue'),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer-actions" }, [
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          class: { disabled: !_vm.accept },
          on: { click: _vm.submit },
        },
        [_vm._v("\n\t\t\tSubmit\n\t\t")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }